import { db } from '../../firebase'; // Firestore configuration
import { collection, getDocs } from 'firebase/firestore';

export const FETCH_FAQ = 'FETCH_FAQ';

export const fetchFAQ = () => async (dispatch) => {
  try {
    const faqCollection = collection(db, 'FAQ');
    const faqSnapshot = await getDocs(faqCollection);
    const faqList = faqSnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
    }));
    dispatch({ type: FETCH_FAQ, payload: faqList });
  } catch (error) {
    console.error('Error fetching FAQ data:', error);
  }
};
